import React from 'react';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';

import { Helmet } from 'react-helmet';

import Footer from '../components/Footer/Footer';

import landingPageStyle from '../assets/jss/material-kit-react/views/landingPage';
import teamStyle from '../assets/jss/material-kit-react/views/landingPageSections/teamStyle';

import { combineStyles } from '../utils/combineStyles';

import AboutSection from './Sections/AboutSection';
import TeamSection from './Sections/TeamSection';

import 'assets/scss/material-kit-react.scss?v=1.4.0';

import { graphql } from 'gatsby';

class Index extends React.Component {
  render () {
    const { classes } = this.props;

    const people = this.props.data.people.edges;
    const alumni = this.props.data.alumni.edges;
    const photos = this.props.data.photos.edges;
    const aboutContent = this.props.data.about;
    const papers = this.props.data.papers;

    return (
      <div>
        <Helmet title={'AskOski'} defer={false} />
        <div className={classes.toc}>
          <div>
            <a href='#about'>
              About
            </a>
          </div>
          <div>
            <a href='#research'>
              Research
            </a>
          </div>
          <div>
            <a href='#team'>
              Team
            </a>
          </div>
          <div>
            <a href='#contact'>
              Contact
            </a>
          </div>
        </div>
        <div style={{ height: '125px' }} />
        <div className={classNames(classes.main, classes.mainRaised, 'js-toc-content')}>
          <div className={classes.container}>
            <AboutSection aboutContent={aboutContent} papers={papers} />
            <TeamSection people={people} alumni={alumni} photos={photos} />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
export const query = graphql`
  query {
    people: allMarkdownRemark(filter: { fileAbsolutePath: { regex : "\/people/(?!(alumni))/" }}, sort: { fields: [frontmatter___zindex, frontmatter___name], order: [ASC, ASC] }) {
      edges {
        node {
          excerpt(pruneLength: 250)
          fileAbsolutePath
          frontmatter {
            name
            title
            email
            website
            linkedin
            zindex
          }
        }
      }
    }
    alumni: allMarkdownRemark(filter: { fileAbsolutePath: { regex : "\/people/alumni/" }}, sort: { fields: [frontmatter___zindex, frontmatter___name], order: [ASC, ASC] }) {
      edges {
        node {
          excerpt(pruneLength: 250)
          fileAbsolutePath
          frontmatter {
            name
            title
            email
            website
            linkedin
            zindex
          }
        }
      }
    }
    about: markdownRemark(fileAbsolutePath: { regex: "\\/about.md/" }) {
      html
    }
    papers: markdownRemark(fileAbsolutePath: { regex: "\\/papers.md/" }) {
      html
    }
    photos: allImageSharp {
      edges {
        node {
          fluid {
            originalName
            ...GatsbyImageSharpFluid
            presentationWidth
          }
        }
      }
    }
  }
`;
export default withStyles(combineStyles(landingPageStyle, teamStyle))(Index);
